import React, { useState } from 'react';
import { Languages } from '@guestyci/icons/system';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Stack,
} from '@guestyci/arc';
import intl from '@guestyci/localize/intl';
import { useBreakpoint } from '../../utils/useBreakpoint';
import { LANGUAGE_OPTIONS, getLanguage, setLanguage } from '../utils/localeHelper';

const LanguageSelect = ({ onLanguageChange }) => {
  const isDesktop = useBreakpoint('md');
  const [selectedLanguage, setSelectedLanguage] = useState(getLanguage());

  const handleLanguageChange = async (value) => {
    await intl.init({ language: value });
    setLanguage(value);
    setSelectedLanguage(value);
    onLanguageChange?.();
  };

  return (
    <Select value={selectedLanguage} onValueChange={handleLanguageChange}>
      <SelectTrigger size="sm" className="gst-w-auto gst-gap-2">
        <Stack direction="row" spacing={2} align="center">
          <Languages size={16} className="gst-shrink-0" />
          {isDesktop && <SelectValue />}
        </Stack>
      </SelectTrigger>
      <SelectContent>
        {LANGUAGE_OPTIONS.map(({ value, label }) => (
          <SelectItem key={value} value={value}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSelect;
